export default {
    rest_point: 'https://back.enroller.ru/rest', // Адрес REST
    api_url: "https://back.enroller.ru",
    app_env: "prod",
}
